export default class OrganizationSectionFieldAliases {
  static CONTRACT_NUMBER = 'contract_number'
  static CONTRACT_DATE_OF = 'contract_date'
  static CONTRACT_DATE_TO = 'contract_end_date'
  static CONTRACT_ORG_NAME = 'contract_org_name'
  static CONTRACT_ORG_INN = 'contract_org_inn'
}
